module.exports = __webpack_public_path__ + "static/media/dobsovic.3f796d50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/dobsovic.jpg
// module id = 494
// module chunks = 0